$('.invoice-payment-input')
    .keydown(function (event) {
        // On Enter
        if (event.keyCode === 13) {
            const form = event.target.form;

            Livewire.dispatch('invoicePaymentUpdated', {
                formData: $(form).serializeArray()
            });
        }
    }).blur(function (event) {
        // On leave input field
        const form = event.target.form;

        Livewire.dispatch('invoicePaymentUpdated', {
            formData: $(form).serializeArray()
        });
    });

